import arrow_right from './arrow-right.svg';
import brakes from './brakes.svg';
import car from './car.svg';
import certified from './certified.svg';
import diagnosis from './diagnosis.svg';
import electrical from './electrical.svg';
import engine from './engine.svg';
import european_cars from './european-cars.svg';
import hand_car from './hand-car.svg';
import hand_mobile from './hand-mobile.svg';
import hand_money from './hand-money.svg';
import information from './information-primary.svg';
import love from './love.svg';
import phone from './phone.svg';
import question_primary from './question-primary.svg';
import question_secondary from './question-secondary.svg';
import question from './question.svg';
import security from './security.svg';
import suspension from './suspension.svg';
import user from './user.svg';

export default {
  arrow_right,
  brakes,
  car,
  certified,
  diagnosis,
  electrical,
  engine,
  european_cars,
  hand_car,
  hand_mobile,
  hand_money,
  information,
  love,
  phone,
  question,
  question_primary,
  question_secondary,
  security,
  suspension,
  user,
};
